module.exports = __webpack_public_path__ + "static/media/red-number-1.c9fbe448.png";